import { Task } from "../lib/api/tasks";
import { TaskFilters as TaskFiltersType } from "../components/tasks/TaskFilters";

export function useFilteredTasks(tasks: Task[], filters: TaskFiltersType) {
  const filteredTasks = tasks.filter((task) => {
    if (filters.assigneeId && task.assigneeId !== filters.assigneeId) {
      return false;
    }
    if (filters.priority && task.priority !== filters.priority) {
      return false;
    }
    if (filters.type && task.type !== filters.type) {
      return false;
    }
    if (filters.search) {
      const searchLower = filters.search.toLowerCase();
      const matchesTitle = task.title.toLowerCase().includes(searchLower);
      const matchesDescription = task.description
        ?.toLowerCase()
        .includes(searchLower);
      if (!matchesTitle && !matchesDescription) {
        return false;
      }
    }
    return true;
  });

  const tasksByStatus = filteredTasks.reduce(
    (acc, task) => {
      if (!acc[task.status]) acc[task.status] = [];
      acc[task.status].push(task);
      return acc;
    },
    {} as Record<string, Task[]>,
  );

  return { filteredTasks, tasksByStatus };
}
